import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Buyer } from "src/types/Types";

interface BuyersState {
  selectedBuyers: Buyer[];
}

const initialState: BuyersState = {
  selectedBuyers: [],
};

const buyersSlice = createSlice({
  name: "buyersL",
  initialState,
  reducers: {
    setSelectedBuyers: (state, action: PayloadAction<Buyer[]>) => {
      state.selectedBuyers = action.payload;
    },
  },
});

export const { setSelectedBuyers } = buyersSlice.actions;
export default buyersSlice.reducer;
